import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = user
  const [cartCount, setCartCount] = useState(0);

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      try {
        const c = await api.get("/cart");
        setCartCount(c.data.items.reduce((s, i) => s + i.qty, 0));
      } catch {}
    } catch {
      setUser(false);
      setCartCount(0);
    }
  };

  useEffect(() => {
    refreshMe();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("florvanta_token", data.token);
    setUser(data.user);
    await refreshMe();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("florvanta_token", data.token);
    setUser(data.user);
    await refreshMe();
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("florvanta_token");
    setUser(false);
    setCartCount(0);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, cartCount, setCartCount, login, register, logout, refreshMe }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
